<script setup lang="ts">
import { ref } from 'vue'
import { TransitionRoot } from '@headlessui/vue'

import BaseDrawer from '@/components/ContestGame/BaseDrawer.vue'

import type { ContestColor, ContestGameReward, GameContest } from '@/types'

const props = withDefaults(
  defineProps<{
    contestColor: ContestColor
    submitLink?: string
    contestReward?: ContestGameReward
    gameContest: GameContest
  }>(),
  {
    submitLink: '',
    contestReward: undefined,
  },
)

const redirectSubmitLink = () => {
  if (props.submitLink) {
    window.location.href = props.submitLink
  }
}

const animate = ref(false)
setTimeout(() => {
  animate.value = true
}, 1000)

const showButton = ref(false)
setTimeout(() => {
  showButton.value = true
}, 3000)
</script>

<template>
  <div
    class="animate fixed left-1/2 top-20 mx-auto h-32 w-full max-w-[400px] -translate-x-1/2 text-center text-2xl font-bold transition-opacity"
  >
    <p :style="{ color: gameContest?.textColor }">
      {{ contestReward ? gameContest.winningText : gameContest.losingText }}
    </p>
    <TransitionRoot
      :show="animate"
      enter="transform transition ease-in-out duration-500 delay-300"
      enter-from="translate-y-2 opacity-0"
      enter-to="translate-y-0 opacity-100"
      leave="transform transition ease-in-out duration-300"
      leave-from="translate-y-0 opacity-100"
      leave-to="translate-y-2 opacity-0"
    >
      <p class="mt-2 text-2xl font-extrabold" :style="{ color: gameContest?.textColor }">
        {{ contestReward ? contestReward?.name : gameContest.losingTileText }}
      </p>
    </TransitionRoot>

    <p
      v-if="contestReward"
      :style="{ color: gameContest?.textColor }"
      :class="[
        'mt-2 text-base font-medium transition-opacity delay-1000',
        {
          'opacity-100': animate,
          'opacity-0': !animate,
        },
      ]"
    >
      {{ gameContest.sendingNotificationText }}
    </p>
  </div>

  <BaseDrawer
    v-if="showButton && submitLink && contestReward?.type === 'points'"
    :model-value="animate"
    :has-blur="false"
    :btn="{
      text: $t('buttons.goToWebApp'),
      bgColor: contestColor.buttonColor,
      textColor: contestColor.buttonTextColor,
      click: redirectSubmitLink,
    }"
  />
</template>

<style scoped>
.animate {
  animation: animate 3s ease-in-out;
}
@keyframes animate {
  0% {
    transform: translateY(100px) translateX(-50%);
  }
  100% {
    transform: translateY(0) translateX(-50%);
  }
}
</style>
